import { Link } from "react-router-dom";

import { GALA_PLAN, landingPlanBullets } from "../../lib/subscription-plans";

export function GalaEnterpriseCallout({ className = "" }: { className?: string }) {
  const bullets = landingPlanBullets(GALA_PLAN).slice(0, 3);

  return (
    <div
      className={`relative overflow-hidden rounded-2xl border-2 border-brand-200 border-l-4 border-l-brand-500 bg-brand-50 shadow-lg shadow-brand-500/10 ${className}`}
    >
      <div className="absolute inset-0 dot-grid opacity-40 pointer-events-none" aria-hidden />

      <div className="relative flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 p-8 sm:p-10">
        <div className="max-w-2xl">
          <div className="flex flex-wrap items-center gap-2 mb-4">
            <span className="inline-flex items-center rounded-full border border-brand-200 bg-white px-3 py-1 text-xs font-bold uppercase tracking-wide text-brand-700">
              {GALA_PLAN.name}
            </span>
            <span className="inline-flex items-center rounded-full bg-brand-500 px-3 py-1 text-xs font-bold uppercase tracking-wide text-white">
              {GALA_PLAN.tierLabel}
            </span>
          </div>

          <h3 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-gray-900">
            Need something{" "}
            <span className="gradient-text">beyond the standard plans?</span>
          </h3>
          <p className="mt-3 text-sm sm:text-base text-gray-600 leading-relaxed">
            Mix and match features like API access, voice (STT/TTS), POS, and alerts — with
            negotiated online and dine-in limits. Pay only for what you use.
          </p>

          <ul className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-3">
            {bullets.map((item) => (
              <li
                key={item}
                className="feature-card group flex items-start gap-2 rounded-xl px-3.5 py-3 text-sm text-gray-600 cursor-default"
              >
                <svg className="w-4 h-4 shrink-0 text-brand-500 mt-0.5 transition-transform duration-200 group-hover:scale-110" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="leading-snug transition-colors duration-200 group-hover:text-gray-800">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex flex-col gap-3 shrink-0 lg:min-w-[13rem] lg:border-l lg:border-brand-200 lg:pl-8">
          <p className="text-xs font-bold uppercase tracking-widest text-brand-600 lg:text-center">
            Sales-led setup
          </p>
          <Link
            to="/contact?planInterest=gala"
            className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-brand-500 hover:bg-brand-600 text-white text-sm font-bold transition-all btn-glow"
          >
            Discuss a Custom Plan
            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </Link>
          <Link
            to="/contact?purpose=demo"
            className="inline-flex items-center justify-center px-6 py-3 rounded-xl border border-gray-200 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50 hover:border-gray-300 transition-colors"
          >
            Book a Demo
          </Link>
        </div>
      </div>
    </div>
  );
}
